export function getEffectiveOrderIds({
  orderIdFromQuery,
  bookingSelectionOrderIds,
  hasCustomizedPrefilledOrderSelection,
}: {
  orderIdFromQuery?: string
  bookingSelectionOrderIds: Array<string>
  hasCustomizedPrefilledOrderSelection: boolean
}): Array<string> {
  if (!orderIdFromQuery || hasCustomizedPrefilledOrderSelection) {
    return bookingSelectionOrderIds
  }

  return [...new Set([orderIdFromQuery, ...bookingSelectionOrderIds])]
}

export function getNextDismissedPrefilledOrderItemIds({
  tag,
  dismissedPrefilledOrderItemIds,
  prefilledOrderTagsByItemId,
}: {
  tag: string
  dismissedPrefilledOrderItemIds: Array<string>
  prefilledOrderTagsByItemId: Map<string, string>
}): Array<string> {
  const nextDismissedPrefilledOrderItemIds = new Set(dismissedPrefilledOrderItemIds)

  prefilledOrderTagsByItemId.forEach((prefilledTag, itemId) => {
    if (prefilledTag === tag) {
      nextDismissedPrefilledOrderItemIds.add(itemId)
    }
  })

  return [...nextDismissedPrefilledOrderItemIds]
}
